// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"427ea66f","453":"e3999a89","455":"ed7fb4d5","977":"294db2a6"}[chunkId] + ".chunk.js";
};